// extracted by mini-css-extract-plugin
module.exports = {"logo":"FullLogoIcon_logo__yxZgM","logo__hat":"FullLogoIcon_logo__hat__4gYQQ"};